import * as yup from 'yup'

const digits = (value?: string) => (value || '').replace(/\D/g, '')

export const cardSchema = yup.object({
  holder_name: yup
    .string()
    .trim()
    .required('Informe o nome impresso no cartão'),
  document: yup
    .string()
    .required('Informe o CPF ou CNPJ do titular')
    .test('document', 'CPF ou CNPJ inválido', (v) =>
      [11, 14].includes(digits(v).length)
    ),
  card_number: yup
    .string()
    .required('Informe o número do cartão')
    .test('card', 'Número do cartão inválido', (v) =>
      [15, 16].includes(digits(v).length)
    ),
  expiration: yup
    .string()
    .required('Informe a validade')
    .test('expiration', 'Validade inválida', (v) => {
      const value = digits(v)
      if (value.length !== 4) return false
      const month = Number(value.slice(0, 2))
      const year = 2000 + Number(value.slice(2))
      if (month < 1 || month > 12) return false
      const now = new Date()
      return (
        year > now.getFullYear() ||
        (year === now.getFullYear() && month >= now.getMonth() + 1)
      )
    }),
  cvv: yup
    .string()
    .required('Informe o código de segurança')
    .test('cvv', 'CVV inválido', (v) => [3, 4].includes(digits(v).length))
})

export type CardFormData = yup.InferType<typeof cardSchema>
